import { render, staticRenderFns } from "./classMates.vue?vue&type=template&id=13a1acb3&scoped=true&"
import script from "./classMates.vue?vue&type=script&lang=js&"
export * from "./classMates.vue?vue&type=script&lang=js&"
import style0 from "./classMates.vue?vue&type=style&index=0&id=13a1acb3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1acb3",
  null
  
)

export default component.exports